import { useState, useEffect } from "react";
import classNames from "classnames";

import MoonIcon from "assets/icons/MoonIcon";
import useDragging from "hooks/useDragging";
import SunIcon from "assets/icons/SunIcon";

import styles from "./style.module.scss";

export enum THEME {
  LIGHT = "light",
  DARK = "dark",
}

const ThemeToggle = () => {
  const initialTheme = localStorage.getItem("theme") || "dark";
  const [savedTheme, setSavedTheme] = useState<THEME>(initialTheme as THEME);
  const isDark = savedTheme === THEME.DARK;

  const onDragComplete = (dragOffset: number) => {
    if (dragOffset > 10) {
      setSavedTheme(THEME.LIGHT);
    } else if (dragOffset < -10) {
      setSavedTheme(THEME.DARK);
    }
  };

  const { isDragging, handleMouseDown } = useDragging({
    onDragComplete,
    threshold: 10,
  });

  useEffect(() => {
    if (savedTheme === THEME.LIGHT) {
      document.body.setAttribute("data-theme", THEME.LIGHT);
      localStorage.setItem("theme", THEME.LIGHT);
    } else {
      document.body.setAttribute("data-theme", THEME.DARK);
      localStorage.setItem("theme", THEME.DARK);
    }
  }, [savedTheme]);

  const containerClassnames = classNames(styles.toggleContainer, {
    [styles.grabbing]: isDragging,
  });

  const darkIconClassnames = classNames(styles.iconContainer, {
    [styles.active]: isDark,
  });

  const lightIconClassnames = classNames(styles.iconContainer, {
    [styles.active]: !isDark,
  });

  const sliderClassnames = classNames(
    styles.slider,
    isDark ? styles.leftAlign : styles.rightAlign,
    { [styles.grabbing]: isDragging }
  );

  return (
    <div className={containerClassnames} data-testid="theme-toggle-container">
      <div
        className={sliderClassnames}
        data-testid="theme-toggle-slider"
        onMouseDown={handleMouseDown}
      ></div>
      <div
        className={darkIconClassnames}
        onClick={() => setSavedTheme(THEME.DARK)}
        data-testid="dark-theme-icon"
      >
        <MoonIcon />
      </div>
      <div
        className={lightIconClassnames}
        onClick={() => setSavedTheme(THEME.LIGHT)}
        data-testid="light-theme-icon"
      >
        <SunIcon />
      </div>
    </div>
  );
};

export default ThemeToggle;
